import React from 'react';
import { useTranslation } from '../../i18n/LanguageProvider';

const AccessNotificationDialog = () => {
  const { t } = useTranslation();
  return (
    <>
      <div
        style={{
          textAlign: 'center',
          marginTop: '10px',
          marginBottom: '10px'
        }}
      >
        {t('dialogs.notificationAccess.question')}
      </div>
      <div
        style={{
          textAlign: 'center',
          marginTop: '10px',
          marginBottom: '10px',
          fontSize: '13px'
        }}
      >
        ({t('dialogs.notificationAccess.hint')})
      </div>
    </>
  );
};

export default AccessNotificationDialog;
